export const SAVE_ACCOUNT = 'SAVE_ACCOUNT';
export const SAVE_ACCOUNT_PROFILE = 'SAVE_ACCOUNT_PROFILE';
export const SAVE_ACCOUNT_BRANDING = 'SAVE_ACCOUNT_BRANDING';
export const SAVE_ACCOUNT_SCHEDULE_SETTINGS = 'SAVE_ACCOUNT_SCHEDULE_SETTINGS';
export const SAVE_ACCOUNT_REGIONAL_SETTINGS = 'SAVE_ACCOUNT_REGIONAL_SETTINGS'; 
export const SAVE_ACCOUNT_COMMUNICATION_SETTINGS = 'SAVE_ACCOUNT_COMMUNICATION_SETTINGS';
export const SAVE_ACCOUNT_REQUEST_SETTINGS = 'SAVE_ACCOUNT_REQUEST_SETTINGS';
export const SAVE_ACCOUNT_QUOTE_SETTINGS = 'SAVE_ACCOUNT_QUOTE_SETTINGS';
export const SAVE_ACCOUNT_JOB_SETTINGS = 'SAVE_ACCOUNT_JOB_SETTINGS';
export const SAVE_ACCOUNT_JOB_TYPES = 'SAVE_ACCOUNT_JOB_TYPES';
export const SAVE_ACCOUNT_JOB_STATUSES = 'SAVE_ACCOUNT_JOB_STATUSES';
export const SAVE_ACCOUNT_INVOICE_SETTINGS = 'SAVE_ACCOUNT_INVOICE_SETTINGS';
export const SAVE_ACCOUNT_LICENSE_SETTINGS = 'SAVE_ACCOUNT_LICENSE_SETTINGS';  